import superAdminDashboard from "./dashboardRouter";
import companyRouter from "./companyRouter";
import companyRequestRouter from "./companyRequestRouter";
import mailSending from "./mailSending";
import coupon from "./coupon";
import rolesRouter from "./rolesRouter";
import profileRouter from "./profileRouter";
import userRouter from "./userRouter";

const allSuperAdminRoutes = [
    ...superAdminDashboard,
    ...companyRouter,
    ...companyRequestRouter,
    ...mailSending,
    ...coupon,
    ...rolesRouter,
    ...profileRouter,
    ...userRouter,
];

export default allSuperAdminRoutes;
